"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactIconBase = _interopRequireDefault(require("react-icon-base"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var CategoryCodePROV = function CategoryCodePROV(props) {
  return _react.default.createElement(_reactIconBase.default, _extends({
    viewBox: "0 0 16 16"
  }, props), _react.default.createElement("g", null, _react.default.createElement("title", null, "CategoryCodePROV"), _react.default.createElement("path", {
    d: "M14.255,4.772a.335.335,0,0,0-.318-.027l-.155.068A14.477,14.477,0,0,1,8,6.277,14.477,14.477,0,0,1,2.218,4.813l-.155-.068a.335.335,0,0,0-.469.307V6.6a.335.335,0,0,0,.313.334c2.817.182,5.2,2.795,5.418,5.948a.335.335,0,0,0,.334.312h.677a.336.336,0,0,0,.335-.314c.2-3.183,2.578-5.8,5.418-5.949a.336.336,0,0,0,.317-.335V5.052A.335.335,0,0,0,14.255,4.772Z"
  })));
};

var _default = CategoryCodePROV;
exports.default = _default;